import { Filter } from '@fabric-ui/components';
import { FieldType, SchemaTypes, typeLabelMap } from '../../views/Sources/Mapping/types';

const FILTER_METADATA_KEYS = new Set(['isHistorical', '_metadata']);

export const isDateFilterField = (fieldName: string | null | undefined, fieldMap: Record<string, { type?: unknown }>): boolean =>
  !!fieldName && [FieldType.Date, FieldType.DateTime].includes(fieldMap[fieldName]?.type as string);

// Enum fields are surfaced as plain strings by useEntities#getType (AVA-12425 - not fully supported yet),
// so we look at the un-collapsed originalType.kind to detect them. This is needed to restrict the
// operators shown to the ones the BE can actually compile for an enum-backed field (AVA-25205):
// only EQUALS/NOT_EQUAL go through the enum-aware CEL codepath, everything else assumes a string.
export const isEnumFilterField = (
  fieldName: string | null | undefined,
  fieldMap: Record<string, { originalType?: { kind?: unknown } }>
): boolean => !!fieldName && typeLabelMap[fieldMap[fieldName]?.originalType?.kind as string] === SchemaTypes.ENUM;

export const getFilterTypeName = (
  conditionType: string,
  isRepeated: boolean | undefined,
  fieldName: string | null | undefined,
  fieldMap: Record<string, { originalType?: { kind?: unknown } }>
): string => `${isEnumFilterField(fieldName, fieldMap) ? SchemaTypes.ENUM : conditionType}${isRepeated ? '[]' : ''}`;

export const preserveFilterMetadata = (filter: Filter): Partial<Filter & { _metadata?: unknown }> =>
  Object.fromEntries(Object.entries(filter).filter(([key]) => FILTER_METADATA_KEYS.has(key))) as Partial<Filter & { _metadata?: unknown }>;
